import {
  BsEnvelope,
  BsTelephone,
  BsGeoAlt,
  BsWhatsapp,
  BsLinkedin,
  BsArrowRight,
} from "react-icons/bs";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row gy-5">
          {/* Company */}

          <div className="col-lg-5">
            <h2 className="footer-logo azonic">ADYAH</h2>

            <p className="footer-description">
              Adyah Consultancy Services helps businesses grow through
              high-performance websites, social media marketing and AI-powered
              automation solutions.
            </p>

            <div className="footer-trust">
              <span>✓ Business Focused Solutions</span>
              <span>✓ Modern Technology Stack</span>
              <span>✓ Long-Term Support</span>
            </div>

            <div className="footer-social">
              <a
                href="https://wa.me/919867672919"
                target="_blank"
                rel="noreferrer"
              >
                <BsWhatsapp />
              </a>

              <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                <BsLinkedin />
              </a>
            </div>
          </div>

          {/* Services */}

          <div className="col-lg-3 col-md-6">
            <h5>Services</h5>

            <ul className="footer-links">
              <li>
                <a href="#services">
                  <BsArrowRight />
                  Website Development
                </a>
              </li>

              <li>
                <a href="#services">
                  <BsArrowRight />
                  Social Media Marketing
                </a>
              </li>

              <li>
                <a href="#ai">
                  <BsArrowRight />
                  AI Automation
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}

          <div className="col-lg-4 col-md-6">
            <h5>Contact</h5>

            <div className="footer-contact">
              <div>
                <BsEnvelope />
                <a href="mailto:team@adyah.co.in">team@adyah.co.in</a>
              </div>

              <div>
                <BsTelephone />
                <a href="tel:+919867672919">+91 98676 72919</a>
              </div>

              <div>
                <BsGeoAlt />
                <span>Mumbai, Maharashtra, India</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="footer-copy">
            © 2026 Adyah Consultancy Services. All rights reserved.
          </div>

          <div className="footer-tagline">
            Websites • Marketing • AI Automation
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
